<template>
<v-app>
<v-main
    v-if="organization_account != null"
>

   <m-make-payment-app-bar
        :value="organization_label"
        :banner_branding="banner_branding"
    />

    <v-container>
        <div
            style="margin-left: 15px; margin-right: 15px; margin-top: 15px;"
        >

        <h2>Request</h2>

        <v-text-field
            label="Subject"
            :value="request.request_subject"
            readonly
            disabled
        />

        <v-textarea
            label="Body"
            :value="request.request_body"
            readonly
            disabled
            auto-grow
        />

        <div
            v-if="replies.length > 0"
        >
            <h2
                style="margin-bottom: 15px"
            >
                Replies
            </h2>
            
            <div
                v-for="(item, index) in replies"
                :key="'reply'+index"
            >
                <p class="author_label">{{item.author}}</p>
                <div
                    class="note_text"
                    v-html="$rc.htmlLinebreak(item.reply)"
                >
                </div>
            </div>
        </div>

        <h2>Message {{organization_label}}</h2>

        <v-textarea
            :label="'Message '+organization_label+' (not visible to customer)'"
            v-model="reply_body"
            auto-grow
        />

        <v-row>
            <v-col>
                <v-text-field
                    label="Name"
                    v-model="reply_name"
                />
            </v-col>

            <v-col>
                <v-text-field
                    label="Organization"
                    v-model="reply_org"
                />
            </v-col>
        </v-row>

        <div
            style="text-align: right"
        >
            <v-btn
                color="primary"
                :disbaled="!is_valid"
                v-on:click="onClickSubmit"
            >
                Send
            </v-btn>
        </div>
        
        </div>
    </v-container>

</v-main>


  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>

export default {

    data() {
        return {
            banner_branding: null,
            organization_account: null,
            request: null,

            reply_body: null,
            reply_name: null,
            reply_org: null,
            replies: [],
        }
    },

    mounted () {
        this.loadProfile();
    },   

    methods: {
      loadProfile()
      {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/conversations/comment-request/profile/:comment_request_id',
            
                'params' : {
                        'comment_request_id': this.$route.params.comment_request_id,
                    },
            
                'on_success': (data) => {
                        this.banner_branding = data.banner_branding;
                        this.organization_account = data.organization_account;
                        this.request = data.request;
                        this.replies = data.replies;
                    },
            
                'on_error': 'Unable to get comment request information',
            });
      },

      onClickSubmit()
      {
        this.$rc.rest({
            'spinner': true,
            'endpoint': 'PUT: /api/v1/conversations/comment-request',
        
            'params' : {
                    'organization_id': this.request.organization_id,
                    'comment_reply_id': this.$rc.uuidv4(),
                    'comment_request_id': this.request.comment_request_id,
                    'author': this.reply_name+' @ '+this.reply_org,
                    'reply': this.reply_body,
                    'time_create': Date.now(),
                },
        
            'on_success': (data) => {
                    this.reply_body = null;

                    this.loadProfile();
                },
        
            'on_error': 'Unable to submit reply to this request.',
        });
      },

      isBlank(value)
      {
        if ( value == null ) return false;
        if ( value.trim().length == 0 ) return false;
        return true;

      },
    },

    computed: {
        organization_label()
        {
            if ( this.organization_account == null ) return '';
            return this.organization_account.label;
        },

        is_valid()
        {
            if ( this.isBlank(this.reply_body) ) return false;
            if ( this.isBlank(this.reply_name) ) return false;
            if ( this.isBlank(this.reply_org) ) return false;

            return true;
        },
    },

    watch: {
        reply_body(newValue, oldValue) {
            if ( newValue == null ) return;
            if ( newValue.toLowerCase() != 'sample' ) return;

            this.reply_body = 'This package will be held for pickup at:\n\nWalgreens\n1243 Main St\nAnytowne, NY, 13676\n\nIt should be ready for pickup tomorrow!';
            this.reply_name = 'Sandra Smithington';
            this.reply_org = "Wineshipping";
        }
    },
}
</script>

<style lang="scss" scoped>

.note_text
{
    background-color: rgb(250,250,220);
    
    color: rgb(32,33,36);
    display: inline-block;
    border-radius: 0px;
    font-family: Roboto;

    padding-bottom: 10px;
    padding-left: 14px;
    padding-right: 14px;
    padding-top: 10px;

    line-height: 24px;

    max-width: 460px;

    overflow-wrap: anywhere;

    margin-bottom: 15px;
    padding: 15px;
}

.author_label
{
    font-family: Roboto;
    font-size: 12px;
}

</style>